import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 2rem;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.error};
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 2rem;
  max-width: 600px;
`;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  font-weight: 500;
  
  &:hover {
    text-decoration: underline;
  }
`;

const Unauthorized: React.FC = () => {
  return (
    <Container>
      <Title>Access Denied</Title>
      <Message>
        Sorry, you don't have permission to access this page. If you believe this is an error,
        please contact your administrator.
      </Message>
      <StyledLink to="/">Return to Home</StyledLink>
    </Container>
  );
};

export default Unauthorized; 